// ============================================================================
// marketDisputeConstants — общие константы спора (без зависимостей от RPC).
// Вынесены отдельно, чтобы теги/чтение/UI не тянули друг друга по кругу.
// ============================================================================

/** Тип субъекта тегов: спор ставится на документ «Заявка (маркетплейс)». */
export const DISPUTE_SUBJECT_TYPE = 'document';
export const DISPUTE_SUBJECT_CODE = 'mkt_requests';
